import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import Back1 from '../assets/images/back-home-1.webp';
import BeneficiosPage from '../pages/BeneficiosPage';
import SEO from '../components/SEO';

export const Beneficios = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const isEnglish = currentLang.startsWith('en');
  const canonicalUrl = isEnglish
    ? "https://dynamicore.io/en/benefits"
    : "https://dynamicore.io/beneficios";

  const hreflang = [
    { url: "https://dynamicore.io/beneficios", lang: "es" },
    { url: "https://dynamicore.io/en/benefits", lang: "en-us" }
  ];
  return (
    <Layout backgroundimage={Back1} actionDemo={true}>
      <SEO
        title={t("Beneficios del Software Financiero Modular")}
        description={t('Digitaliza procesos financieros, aumenta tu agilidad operativa, reduce costos y mejora la experiencia del cliente con tecnología avanzada y escalable.')}
        works={[
          t('Core Financiero'),
          t('Fintech'),
          t('Onboarding digital'),
          t('Aprobación de crédito'),
          t('Gestión de cobranza'),
          t('Análisis de crédito'),
          t('Core Bancario'),
          t('Automatización de procesos'),
          t('Procesos digitales'),
          t('Producto financiero'),
          t('Servicios financieros'),
          t('Digitalización de procesos'),
          t('Software financiero'),
          t('Dispersión'),
          t('Reportes automatizados'),
          t('Corebanking'),
          t('Sector financiero'),
          t('SOFIPO'),
          t('SOFOM'),
          t('CNBV'),
          t('Condusef'),
          t('Servicios financieros digitales'),
          t('Plataforma financiera'),
        ]}
        bolImage={false}
        ogImage={`dynamicore-preview.png`}
        twitterImage={`dynamicore-preview.png`}
        canonicalUrl={canonicalUrl}
        hreflang={hreflang}
        // canonicalUrl={`https://dynamicore.io/${i18n.language === 'en' ? 'en/benefits' : 'beneficios'}`}
        // hreflang={[
        //   { url: "https://dynamicore.io/beneficios", lang: "es" },
        //   { url: "https://dynamicore.io/en/benefits", lang: "en-us" }
        // ]}
      />
      <BeneficiosPage/>
    </Layout>
  )
}
